/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AgentInventoryIndexRouteImport } from './routes/agent-inventory/index'
import { Route as AgentInventoryNewRouteImport } from './routes/agent-inventory/new'
import { Route as AiAppsIndexRouteImport } from './routes/ai-apps/index'
import { Route as AiAppsAppIdRouteImport } from './routes/ai-apps/$appId'
import { Route as AiIndexRouteImport } from './routes/ai/index'
import { Route as AuditExplorerIndexRouteImport } from './routes/audit-explorer/index'
import { Route as BaaPreflightIndexRouteImport } from './routes/baa-preflight/index'
import { Route as ConversationsIndexRouteImport } from './routes/conversations/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardInvestigationRouteImport } from './routes/dashboard/investigation'
import { Route as DiscoveryIndexRouteImport } from './routes/discovery/index'
import { Route as DiscoveryConnectRouteImport } from './routes/discovery/connect'
import { Route as EvaluatorsIndexRouteImport } from './routes/evaluators/index'
import { Route as EvaluatorsEvaluatorIdRouteImport } from './routes/evaluators/$evaluatorId'
import { Route as EvaluatorsDashboardRouteImport } from './routes/evaluators/dashboard'
import { Route as EvaluatorsNewRouteImport } from './routes/evaluators/new'
import { Route as FindingsIndexRouteImport } from './routes/findings/index'
import { Route as FindingsFindingIdRouteImport } from './routes/findings/$findingId'
import { Route as ModelCardsIndexRouteImport } from './routes/model-cards/index'
import { Route as PlatformAdminIndexRouteImport } from './routes/platform-admin/index'
import { Route as PlatformAdminTenantIdRouteImport } from './routes/platform-admin/$tenantId'
import { Route as PlatformAdminScheduledJobsRouteImport } from './routes/platform-admin/scheduled-jobs'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as ProfileBasicInformationRouteImport } from './routes/profile/basic-information'
import { Route as ProfilePasswordRouteImport } from './routes/profile/password'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ReviewQueueIndexRouteImport } from './routes/review-queue/index'
import { Route as ReviewQueueActionIdRouteImport } from './routes/review-queue/$actionId'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsRoleBasedAccessRouteImport } from './routes/settings/role-based-access'
import { Route as TenantAdminIndexRouteImport } from './routes/tenant-admin/index'
import { Route as WorkflowBuilderIndexRouteImport } from './routes/workflow-builder/index'
import { Route as AgentInventoryAgentIdEditRouteImport } from './routes/agent-inventory/$agentId/edit'
import { Route as AiAppsAppIdIndexRouteImport } from './routes/ai-apps/$appId/index'
import { Route as AiAppsAppIdAgentsRouteImport } from './routes/ai-apps/$appId/agents'
import { Route as AiAppsAppIdDashboardRouteImport } from './routes/ai-apps/$appId/dashboard'
import { Route as AiAppsAppIdEvaluatorRulesRouteImport } from './routes/ai-apps/$appId/evaluator-rules'
import { Route as AiAppsAppIdModelsRouteImport } from './routes/ai-apps/$appId/models'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'
import { Route as EvaluatorsTestSetsIndexRouteImport } from './routes/evaluators/test-sets/index'
import { Route as EvaluatorsTestSetsTestSetIdRouteImport } from './routes/evaluators/test-sets/$testSetId'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects/$projectId/index'
import { Route as ProjectsProjectIdModelsModelIdRouteImport } from './routes/projects/$projectId/models/$modelId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentInventoryIndexRoute = AgentInventoryIndexRouteImport.update({
  id: '/agent-inventory/',
  path: '/agent-inventory/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentInventoryNewRoute = AgentInventoryNewRouteImport.update({
  id: '/agent-inventory/new',
  path: '/agent-inventory/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AiAppsIndexRoute = AiAppsIndexRouteImport.update({
  id: '/ai-apps/',
  path: '/ai-apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiAppsAppIdRoute = AiAppsAppIdRouteImport.update({
  id: '/ai-apps/$appId',
  path: '/ai-apps/$appId',
  getParentRoute: () => rootRouteImport,
} as any)
const AiIndexRoute = AiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditExplorerIndexRoute = AuditExplorerIndexRouteImport.update({
  id: '/audit-explorer/',
  path: '/audit-explorer/',
  getParentRoute: () => rootRouteImport,
} as any)
const BaaPreflightIndexRoute = BaaPreflightIndexRouteImport.update({
  id: '/baa-preflight/',
  path: '/baa-preflight/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsIndexRoute = ConversationsIndexRouteImport.update({
  id: '/conversations/',
  path: '/conversations/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardInvestigationRoute = DashboardInvestigationRouteImport.update({
  id: '/dashboard/investigation',
  path: '/dashboard/investigation',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoveryIndexRoute = DiscoveryIndexRouteImport.update({
  id: '/discovery/',
  path: '/discovery/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoveryConnectRoute = DiscoveryConnectRouteImport.update({
  id: '/discovery/connect',
  path: '/discovery/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsIndexRoute = EvaluatorsIndexRouteImport.update({
  id: '/evaluators/',
  path: '/evaluators/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsEvaluatorIdRoute = EvaluatorsEvaluatorIdRouteImport.update({
  id: '/evaluators/$evaluatorId',
  path: '/evaluators/$evaluatorId',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsDashboardRoute = EvaluatorsDashboardRouteImport.update({
  id: '/evaluators/dashboard',
  path: '/evaluators/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsNewRoute = EvaluatorsNewRouteImport.update({
  id: '/evaluators/new',
  path: '/evaluators/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FindingsIndexRoute = FindingsIndexRouteImport.update({
  id: '/findings/',
  path: '/findings/',
  getParentRoute: () => rootRouteImport,
} as any)
const FindingsFindingIdRoute = FindingsFindingIdRouteImport.update({
  id: '/findings/$findingId',
  path: '/findings/$findingId',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelCardsIndexRoute = ModelCardsIndexRouteImport.update({
  id: '/model-cards/',
  path: '/model-cards/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformAdminIndexRoute = PlatformAdminIndexRouteImport.update({
  id: '/platform-admin/',
  path: '/platform-admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformAdminTenantIdRoute = PlatformAdminTenantIdRouteImport.update({
  id: '/platform-admin/$tenantId',
  path: '/platform-admin/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformAdminScheduledJobsRoute =
  PlatformAdminScheduledJobsRouteImport.update({
    id: '/platform-admin/scheduled-jobs',
    path: '/platform-admin/scheduled-jobs',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfileBasicInformationRoute = ProfileBasicInformationRouteImport.update({
  id: '/basic-information',
  path: '/basic-information',
  getParentRoute: () => ProfileRoute,
} as any)
const ProfilePasswordRoute = ProfilePasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => ProfileRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewQueueIndexRoute = ReviewQueueIndexRouteImport.update({
  id: '/review-queue/',
  path: '/review-queue/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewQueueActionIdRoute = ReviewQueueActionIdRouteImport.update({
  id: '/review-queue/$actionId',
  path: '/review-queue/$actionId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoleBasedAccessRoute = SettingsRoleBasedAccessRouteImport.update({
  id: '/settings/role-based-access',
  path: '/settings/role-based-access',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantAdminIndexRoute = TenantAdminIndexRouteImport.update({
  id: '/tenant-admin/',
  path: '/tenant-admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowBuilderIndexRoute = WorkflowBuilderIndexRouteImport.update({
  id: '/workflow-builder/',
  path: '/workflow-builder/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentInventoryAgentIdEditRoute =
  AgentInventoryAgentIdEditRouteImport.update({
    id: '/agent-inventory/$agentId/edit',
    path: '/agent-inventory/$agentId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AiAppsAppIdIndexRoute = AiAppsAppIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AiAppsAppIdRoute,
} as any)
const AiAppsAppIdAgentsRoute = AiAppsAppIdAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AiAppsAppIdRoute,
} as any)
const AiAppsAppIdDashboardRoute = AiAppsAppIdDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AiAppsAppIdRoute,
} as any)
const AiAppsAppIdEvaluatorRulesRoute =
  AiAppsAppIdEvaluatorRulesRouteImport.update({
    id: '/evaluator-rules',
    path: '/evaluator-rules',
    getParentRoute: () => AiAppsAppIdRoute,
  } as any)
const AiAppsAppIdModelsRoute = AiAppsAppIdModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AiAppsAppIdRoute,
} as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/auth/google/callback',
  path: '/auth/google/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsTestSetsIndexRoute = EvaluatorsTestSetsIndexRouteImport.update({
  id: '/evaluators/test-sets/',
  path: '/evaluators/test-sets/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluatorsTestSetsTestSetIdRoute =
  EvaluatorsTestSetsTestSetIdRouteImport.update({
    id: '/evaluators/test-sets/$testSetId',
    path: '/evaluators/test-sets/$testSetId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdModelsModelIdRoute =
  ProjectsProjectIdModelsModelIdRouteImport.update({
    id: '/models/$modelId',
    path: '/models/$modelId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/agent-inventory/new': typeof AgentInventoryNewRoute
  '/ai-apps/$appId': typeof AiAppsAppIdRouteWithChildren
  '/dashboard/investigation': typeof DashboardInvestigationRoute
  '/discovery/connect': typeof DiscoveryConnectRoute
  '/evaluators/$evaluatorId': typeof EvaluatorsEvaluatorIdRoute
  '/evaluators/dashboard': typeof EvaluatorsDashboardRoute
  '/evaluators/new': typeof EvaluatorsNewRoute
  '/findings/$findingId': typeof FindingsFindingIdRoute
  '/platform-admin/$tenantId': typeof PlatformAdminTenantIdRoute
  '/platform-admin/scheduled-jobs': typeof PlatformAdminScheduledJobsRoute
  '/profile/basic-information': typeof ProfileBasicInformationRoute
  '/profile/password': typeof ProfilePasswordRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/review-queue/$actionId': typeof ReviewQueueActionIdRoute
  '/settings/role-based-access': typeof SettingsRoleBasedAccessRoute
  '/agent-inventory/': typeof AgentInventoryIndexRoute
  '/ai-apps/': typeof AiAppsIndexRoute
  '/ai/': typeof AiIndexRoute
  '/audit-explorer/': typeof AuditExplorerIndexRoute
  '/baa-preflight/': typeof BaaPreflightIndexRoute
  '/conversations/': typeof ConversationsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/discovery/': typeof DiscoveryIndexRoute
  '/evaluators/': typeof EvaluatorsIndexRoute
  '/findings/': typeof FindingsIndexRoute
  '/model-cards/': typeof ModelCardsIndexRoute
  '/platform-admin/': typeof PlatformAdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/review-queue/': typeof ReviewQueueIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tenant-admin/': typeof TenantAdminIndexRoute
  '/workflow-builder/': typeof WorkflowBuilderIndexRoute
  '/agent-inventory/$agentId/edit': typeof AgentInventoryAgentIdEditRoute
  '/ai-apps/$appId/agents': typeof AiAppsAppIdAgentsRoute
  '/ai-apps/$appId/dashboard': typeof AiAppsAppIdDashboardRoute
  '/ai-apps/$appId/evaluator-rules': typeof AiAppsAppIdEvaluatorRulesRoute
  '/ai-apps/$appId/models': typeof AiAppsAppIdModelsRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/evaluators/test-sets/$testSetId': typeof EvaluatorsTestSetsTestSetIdRoute
  '/ai-apps/$appId/': typeof AiAppsAppIdIndexRoute
  '/evaluators/test-sets/': typeof EvaluatorsTestSetsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/models/$modelId': typeof ProjectsProjectIdModelsModelIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/agent-inventory/new': typeof AgentInventoryNewRoute
  '/dashboard/investigation': typeof DashboardInvestigationRoute
  '/discovery/connect': typeof DiscoveryConnectRoute
  '/evaluators/$evaluatorId': typeof EvaluatorsEvaluatorIdRoute
  '/evaluators/dashboard': typeof EvaluatorsDashboardRoute
  '/evaluators/new': typeof EvaluatorsNewRoute
  '/findings/$findingId': typeof FindingsFindingIdRoute
  '/platform-admin/$tenantId': typeof PlatformAdminTenantIdRoute
  '/platform-admin/scheduled-jobs': typeof PlatformAdminScheduledJobsRoute
  '/profile/basic-information': typeof ProfileBasicInformationRoute
  '/profile/password': typeof ProfilePasswordRoute
  '/review-queue/$actionId': typeof ReviewQueueActionIdRoute
  '/settings/role-based-access': typeof SettingsRoleBasedAccessRoute
  '/agent-inventory': typeof AgentInventoryIndexRoute
  '/ai-apps': typeof AiAppsIndexRoute
  '/ai': typeof AiIndexRoute
  '/audit-explorer': typeof AuditExplorerIndexRoute
  '/baa-preflight': typeof BaaPreflightIndexRoute
  '/conversations': typeof ConversationsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/discovery': typeof DiscoveryIndexRoute
  '/evaluators': typeof EvaluatorsIndexRoute
  '/findings': typeof FindingsIndexRoute
  '/model-cards': typeof ModelCardsIndexRoute
  '/platform-admin': typeof PlatformAdminIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/review-queue': typeof ReviewQueueIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tenant-admin': typeof TenantAdminIndexRoute
  '/workflow-builder': typeof WorkflowBuilderIndexRoute
  '/agent-inventory/$agentId/edit': typeof AgentInventoryAgentIdEditRoute
  '/ai-apps/$appId/agents': typeof AiAppsAppIdAgentsRoute
  '/ai-apps/$appId/dashboard': typeof AiAppsAppIdDashboardRoute
  '/ai-apps/$appId/evaluator-rules': typeof AiAppsAppIdEvaluatorRulesRoute
  '/ai-apps/$appId/models': typeof AiAppsAppIdModelsRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/evaluators/test-sets/$testSetId': typeof EvaluatorsTestSetsTestSetIdRoute
  '/ai-apps/$appId': typeof AiAppsAppIdIndexRoute
  '/evaluators/test-sets': typeof EvaluatorsTestSetsIndexRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/models/$modelId': typeof ProjectsProjectIdModelsModelIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/agent-inventory/new': typeof AgentInventoryNewRoute
  '/ai-apps/$appId': typeof AiAppsAppIdRouteWithChildren
  '/dashboard/investigation': typeof DashboardInvestigationRoute
  '/discovery/connect': typeof DiscoveryConnectRoute
  '/evaluators/$evaluatorId': typeof EvaluatorsEvaluatorIdRoute
  '/evaluators/dashboard': typeof EvaluatorsDashboardRoute
  '/evaluators/new': typeof EvaluatorsNewRoute
  '/findings/$findingId': typeof FindingsFindingIdRoute
  '/platform-admin/$tenantId': typeof PlatformAdminTenantIdRoute
  '/platform-admin/scheduled-jobs': typeof PlatformAdminScheduledJobsRoute
  '/profile/basic-information': typeof ProfileBasicInformationRoute
  '/profile/password': typeof ProfilePasswordRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/review-queue/$actionId': typeof ReviewQueueActionIdRoute
  '/settings/role-based-access': typeof SettingsRoleBasedAccessRoute
  '/agent-inventory/': typeof AgentInventoryIndexRoute
  '/ai-apps/': typeof AiAppsIndexRoute
  '/ai/': typeof AiIndexRoute
  '/audit-explorer/': typeof AuditExplorerIndexRoute
  '/baa-preflight/': typeof BaaPreflightIndexRoute
  '/conversations/': typeof ConversationsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/discovery/': typeof DiscoveryIndexRoute
  '/evaluators/': typeof EvaluatorsIndexRoute
  '/findings/': typeof FindingsIndexRoute
  '/model-cards/': typeof ModelCardsIndexRoute
  '/platform-admin/': typeof PlatformAdminIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/review-queue/': typeof ReviewQueueIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tenant-admin/': typeof TenantAdminIndexRoute
  '/workflow-builder/': typeof WorkflowBuilderIndexRoute
  '/agent-inventory/$agentId/edit': typeof AgentInventoryAgentIdEditRoute
  '/ai-apps/$appId/agents': typeof AiAppsAppIdAgentsRoute
  '/ai-apps/$appId/dashboard': typeof AiAppsAppIdDashboardRoute
  '/ai-apps/$appId/evaluator-rules': typeof AiAppsAppIdEvaluatorRulesRoute
  '/ai-apps/$appId/models': typeof AiAppsAppIdModelsRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/evaluators/test-sets/$testSetId': typeof EvaluatorsTestSetsTestSetIdRoute
  '/ai-apps/$appId/': typeof AiAppsAppIdIndexRoute
  '/evaluators/test-sets/': typeof EvaluatorsTestSetsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/models/$modelId': typeof ProjectsProjectIdModelsModelIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/reset-password'
    | '/signup'
    | '/agent-inventory/new'
    | '/ai-apps/$appId'
    | '/dashboard/investigation'
    | '/discovery/connect'
    | '/evaluators/$evaluatorId'
    | '/evaluators/dashboard'
    | '/evaluators/new'
    | '/findings/$findingId'
    | '/platform-admin/$tenantId'
    | '/platform-admin/scheduled-jobs'
    | '/profile/basic-information'
    | '/profile/password'
    | '/projects/$projectId'
    | '/review-queue/$actionId'
    | '/settings/role-based-access'
    | '/agent-inventory/'
    | '/ai-apps/'
    | '/ai/'
    | '/audit-explorer/'
    | '/baa-preflight/'
    | '/conversations/'
    | '/dashboard/'
    | '/discovery/'
    | '/evaluators/'
    | '/findings/'
    | '/model-cards/'
    | '/platform-admin/'
    | '/profile/'
    | '/projects/'
    | '/review-queue/'
    | '/settings/'
    | '/tenant-admin/'
    | '/workflow-builder/'
    | '/agent-inventory/$agentId/edit'
    | '/ai-apps/$appId/agents'
    | '/ai-apps/$appId/dashboard'
    | '/ai-apps/$appId/evaluator-rules'
    | '/ai-apps/$appId/models'
    | '/auth/google/callback'
    | '/evaluators/test-sets/$testSetId'
    | '/ai-apps/$appId/'
    | '/evaluators/test-sets/'
    | '/projects/$projectId/'
    | '/projects/$projectId/models/$modelId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/agent-inventory/new'
    | '/dashboard/investigation'
    | '/discovery/connect'
    | '/evaluators/$evaluatorId'
    | '/evaluators/dashboard'
    | '/evaluators/new'
    | '/findings/$findingId'
    | '/platform-admin/$tenantId'
    | '/platform-admin/scheduled-jobs'
    | '/profile/basic-information'
    | '/profile/password'
    | '/review-queue/$actionId'
    | '/settings/role-based-access'
    | '/agent-inventory'
    | '/ai-apps'
    | '/ai'
    | '/audit-explorer'
    | '/baa-preflight'
    | '/conversations'
    | '/dashboard'
    | '/discovery'
    | '/evaluators'
    | '/findings'
    | '/model-cards'
    | '/platform-admin'
    | '/profile'
    | '/projects'
    | '/review-queue'
    | '/settings'
    | '/tenant-admin'
    | '/workflow-builder'
    | '/agent-inventory/$agentId/edit'
    | '/ai-apps/$appId/agents'
    | '/ai-apps/$appId/dashboard'
    | '/ai-apps/$appId/evaluator-rules'
    | '/ai-apps/$appId/models'
    | '/auth/google/callback'
    | '/evaluators/test-sets/$testSetId'
    | '/ai-apps/$appId'
    | '/evaluators/test-sets'
    | '/projects/$projectId'
    | '/projects/$projectId/models/$modelId'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/reset-password'
    | '/signup'
    | '/agent-inventory/new'
    | '/ai-apps/$appId'
    | '/dashboard/investigation'
    | '/discovery/connect'
    | '/evaluators/$evaluatorId'
    | '/evaluators/dashboard'
    | '/evaluators/new'
    | '/findings/$findingId'
    | '/platform-admin/$tenantId'
    | '/platform-admin/scheduled-jobs'
    | '/profile/basic-information'
    | '/profile/password'
    | '/projects/$projectId'
    | '/review-queue/$actionId'
    | '/settings/role-based-access'
    | '/agent-inventory/'
    | '/ai-apps/'
    | '/ai/'
    | '/audit-explorer/'
    | '/baa-preflight/'
    | '/conversations/'
    | '/dashboard/'
    | '/discovery/'
    | '/evaluators/'
    | '/findings/'
    | '/model-cards/'
    | '/platform-admin/'
    | '/profile/'
    | '/projects/'
    | '/review-queue/'
    | '/settings/'
    | '/tenant-admin/'
    | '/workflow-builder/'
    | '/agent-inventory/$agentId/edit'
    | '/ai-apps/$appId/agents'
    | '/ai-apps/$appId/dashboard'
    | '/ai-apps/$appId/evaluator-rules'
    | '/ai-apps/$appId/models'
    | '/auth/google/callback'
    | '/evaluators/test-sets/$testSetId'
    | '/ai-apps/$appId/'
    | '/evaluators/test-sets/'
    | '/projects/$projectId/'
    | '/projects/$projectId/models/$modelId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  AgentInventoryNewRoute: typeof AgentInventoryNewRoute
  AiAppsAppIdRoute: typeof AiAppsAppIdRouteWithChildren
  DashboardInvestigationRoute: typeof DashboardInvestigationRoute
  DiscoveryConnectRoute: typeof DiscoveryConnectRoute
  EvaluatorsEvaluatorIdRoute: typeof EvaluatorsEvaluatorIdRoute
  EvaluatorsDashboardRoute: typeof EvaluatorsDashboardRoute
  EvaluatorsNewRoute: typeof EvaluatorsNewRoute
  FindingsFindingIdRoute: typeof FindingsFindingIdRoute
  PlatformAdminTenantIdRoute: typeof PlatformAdminTenantIdRoute
  PlatformAdminScheduledJobsRoute: typeof PlatformAdminScheduledJobsRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ReviewQueueActionIdRoute: typeof ReviewQueueActionIdRoute
  SettingsRoleBasedAccessRoute: typeof SettingsRoleBasedAccessRoute
  AgentInventoryIndexRoute: typeof AgentInventoryIndexRoute
  AiAppsIndexRoute: typeof AiAppsIndexRoute
  AiIndexRoute: typeof AiIndexRoute
  AuditExplorerIndexRoute: typeof AuditExplorerIndexRoute
  BaaPreflightIndexRoute: typeof BaaPreflightIndexRoute
  ConversationsIndexRoute: typeof ConversationsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DiscoveryIndexRoute: typeof DiscoveryIndexRoute
  EvaluatorsIndexRoute: typeof EvaluatorsIndexRoute
  FindingsIndexRoute: typeof FindingsIndexRoute
  ModelCardsIndexRoute: typeof ModelCardsIndexRoute
  PlatformAdminIndexRoute: typeof PlatformAdminIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ReviewQueueIndexRoute: typeof ReviewQueueIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TenantAdminIndexRoute: typeof TenantAdminIndexRoute
  WorkflowBuilderIndexRoute: typeof WorkflowBuilderIndexRoute
  AgentInventoryAgentIdEditRoute: typeof AgentInventoryAgentIdEditRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
  EvaluatorsTestSetsTestSetIdRoute: typeof EvaluatorsTestSetsTestSetIdRoute
  EvaluatorsTestSetsIndexRoute: typeof EvaluatorsTestSetsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-inventory/': {
      id: '/agent-inventory/'
      path: '/agent-inventory'
      fullPath: '/agent-inventory/'
      preLoaderRoute: typeof AgentInventoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-inventory/new': {
      id: '/agent-inventory/new'
      path: '/agent-inventory/new'
      fullPath: '/agent-inventory/new'
      preLoaderRoute: typeof AgentInventoryNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-apps/': {
      id: '/ai-apps/'
      path: '/ai-apps'
      fullPath: '/ai-apps/'
      preLoaderRoute: typeof AiAppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-apps/$appId': {
      id: '/ai-apps/$appId'
      path: '/ai-apps/$appId'
      fullPath: '/ai-apps/$appId'
      preLoaderRoute: typeof AiAppsAppIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai/': {
      id: '/ai/'
      path: '/ai'
      fullPath: '/ai/'
      preLoaderRoute: typeof AiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-explorer/': {
      id: '/audit-explorer/'
      path: '/audit-explorer'
      fullPath: '/audit-explorer/'
      preLoaderRoute: typeof AuditExplorerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/baa-preflight/': {
      id: '/baa-preflight/'
      path: '/baa-preflight'
      fullPath: '/baa-preflight/'
      preLoaderRoute: typeof BaaPreflightIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/': {
      id: '/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof ConversationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/investigation': {
      id: '/dashboard/investigation'
      path: '/dashboard/investigation'
      fullPath: '/dashboard/investigation'
      preLoaderRoute: typeof DashboardInvestigationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discovery/': {
      id: '/discovery/'
      path: '/discovery'
      fullPath: '/discovery/'
      preLoaderRoute: typeof DiscoveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discovery/connect': {
      id: '/discovery/connect'
      path: '/discovery/connect'
      fullPath: '/discovery/connect'
      preLoaderRoute: typeof DiscoveryConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/': {
      id: '/evaluators/'
      path: '/evaluators'
      fullPath: '/evaluators/'
      preLoaderRoute: typeof EvaluatorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/$evaluatorId': {
      id: '/evaluators/$evaluatorId'
      path: '/evaluators/$evaluatorId'
      fullPath: '/evaluators/$evaluatorId'
      preLoaderRoute: typeof EvaluatorsEvaluatorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/dashboard': {
      id: '/evaluators/dashboard'
      path: '/evaluators/dashboard'
      fullPath: '/evaluators/dashboard'
      preLoaderRoute: typeof EvaluatorsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/new': {
      id: '/evaluators/new'
      path: '/evaluators/new'
      fullPath: '/evaluators/new'
      preLoaderRoute: typeof EvaluatorsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/findings/': {
      id: '/findings/'
      path: '/findings'
      fullPath: '/findings/'
      preLoaderRoute: typeof FindingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/findings/$findingId': {
      id: '/findings/$findingId'
      path: '/findings/$findingId'
      fullPath: '/findings/$findingId'
      preLoaderRoute: typeof FindingsFindingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/model-cards/': {
      id: '/model-cards/'
      path: '/model-cards'
      fullPath: '/model-cards/'
      preLoaderRoute: typeof ModelCardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-admin/': {
      id: '/platform-admin/'
      path: '/platform-admin'
      fullPath: '/platform-admin/'
      preLoaderRoute: typeof PlatformAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-admin/$tenantId': {
      id: '/platform-admin/$tenantId'
      path: '/platform-admin/$tenantId'
      fullPath: '/platform-admin/$tenantId'
      preLoaderRoute: typeof PlatformAdminTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform-admin/scheduled-jobs': {
      id: '/platform-admin/scheduled-jobs'
      path: '/platform-admin/scheduled-jobs'
      fullPath: '/platform-admin/scheduled-jobs'
      preLoaderRoute: typeof PlatformAdminScheduledJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/basic-information': {
      id: '/profile/basic-information'
      path: '/basic-information'
      fullPath: '/profile/basic-information'
      preLoaderRoute: typeof ProfileBasicInformationRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/password': {
      id: '/profile/password'
      path: '/password'
      fullPath: '/profile/password'
      preLoaderRoute: typeof ProfilePasswordRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-queue/': {
      id: '/review-queue/'
      path: '/review-queue'
      fullPath: '/review-queue/'
      preLoaderRoute: typeof ReviewQueueIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review-queue/$actionId': {
      id: '/review-queue/$actionId'
      path: '/review-queue/$actionId'
      fullPath: '/review-queue/$actionId'
      preLoaderRoute: typeof ReviewQueueActionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/role-based-access': {
      id: '/settings/role-based-access'
      path: '/settings/role-based-access'
      fullPath: '/settings/role-based-access'
      preLoaderRoute: typeof SettingsRoleBasedAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenant-admin/': {
      id: '/tenant-admin/'
      path: '/tenant-admin'
      fullPath: '/tenant-admin/'
      preLoaderRoute: typeof TenantAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow-builder/': {
      id: '/workflow-builder/'
      path: '/workflow-builder'
      fullPath: '/workflow-builder/'
      preLoaderRoute: typeof WorkflowBuilderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-inventory/$agentId/edit': {
      id: '/agent-inventory/$agentId/edit'
      path: '/agent-inventory/$agentId/edit'
      fullPath: '/agent-inventory/$agentId/edit'
      preLoaderRoute: typeof AgentInventoryAgentIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-apps/$appId/': {
      id: '/ai-apps/$appId/'
      path: '/'
      fullPath: '/ai-apps/$appId/'
      preLoaderRoute: typeof AiAppsAppIdIndexRouteImport
      parentRoute: typeof AiAppsAppIdRoute
    }
    '/ai-apps/$appId/agents': {
      id: '/ai-apps/$appId/agents'
      path: '/agents'
      fullPath: '/ai-apps/$appId/agents'
      preLoaderRoute: typeof AiAppsAppIdAgentsRouteImport
      parentRoute: typeof AiAppsAppIdRoute
    }
    '/ai-apps/$appId/dashboard': {
      id: '/ai-apps/$appId/dashboard'
      path: '/dashboard'
      fullPath: '/ai-apps/$appId/dashboard'
      preLoaderRoute: typeof AiAppsAppIdDashboardRouteImport
      parentRoute: typeof AiAppsAppIdRoute
    }
    '/ai-apps/$appId/evaluator-rules': {
      id: '/ai-apps/$appId/evaluator-rules'
      path: '/evaluator-rules'
      fullPath: '/ai-apps/$appId/evaluator-rules'
      preLoaderRoute: typeof AiAppsAppIdEvaluatorRulesRouteImport
      parentRoute: typeof AiAppsAppIdRoute
    }
    '/ai-apps/$appId/models': {
      id: '/ai-apps/$appId/models'
      path: '/models'
      fullPath: '/ai-apps/$appId/models'
      preLoaderRoute: typeof AiAppsAppIdModelsRouteImport
      parentRoute: typeof AiAppsAppIdRoute
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/auth/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/test-sets/': {
      id: '/evaluators/test-sets/'
      path: '/evaluators/test-sets'
      fullPath: '/evaluators/test-sets/'
      preLoaderRoute: typeof EvaluatorsTestSetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluators/test-sets/$testSetId': {
      id: '/evaluators/test-sets/$testSetId'
      path: '/evaluators/test-sets/$testSetId'
      fullPath: '/evaluators/test-sets/$testSetId'
      preLoaderRoute: typeof EvaluatorsTestSetsTestSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/models/$modelId': {
      id: '/projects/$projectId/models/$modelId'
      path: '/models/$modelId'
      fullPath: '/projects/$projectId/models/$modelId'
      preLoaderRoute: typeof ProjectsProjectIdModelsModelIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
  }
}

interface ProfileRouteChildren {
  ProfileBasicInformationRoute: typeof ProfileBasicInformationRoute
  ProfilePasswordRoute: typeof ProfilePasswordRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileBasicInformationRoute: ProfileBasicInformationRoute,
  ProfilePasswordRoute: ProfilePasswordRoute,
  ProfileIndexRoute: ProfileIndexRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface AiAppsAppIdRouteChildren {
  AiAppsAppIdAgentsRoute: typeof AiAppsAppIdAgentsRoute
  AiAppsAppIdDashboardRoute: typeof AiAppsAppIdDashboardRoute
  AiAppsAppIdEvaluatorRulesRoute: typeof AiAppsAppIdEvaluatorRulesRoute
  AiAppsAppIdModelsRoute: typeof AiAppsAppIdModelsRoute
  AiAppsAppIdIndexRoute: typeof AiAppsAppIdIndexRoute
}

const AiAppsAppIdRouteChildren: AiAppsAppIdRouteChildren = {
  AiAppsAppIdAgentsRoute: AiAppsAppIdAgentsRoute,
  AiAppsAppIdDashboardRoute: AiAppsAppIdDashboardRoute,
  AiAppsAppIdEvaluatorRulesRoute: AiAppsAppIdEvaluatorRulesRoute,
  AiAppsAppIdModelsRoute: AiAppsAppIdModelsRoute,
  AiAppsAppIdIndexRoute: AiAppsAppIdIndexRoute,
}

const AiAppsAppIdRouteWithChildren = AiAppsAppIdRoute._addFileChildren(
  AiAppsAppIdRouteChildren,
)

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  ProjectsProjectIdModelsModelIdRoute: typeof ProjectsProjectIdModelsModelIdRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
  ProjectsProjectIdModelsModelIdRoute: ProjectsProjectIdModelsModelIdRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  AgentInventoryNewRoute: AgentInventoryNewRoute,
  AiAppsAppIdRoute: AiAppsAppIdRouteWithChildren,
  DashboardInvestigationRoute: DashboardInvestigationRoute,
  DiscoveryConnectRoute: DiscoveryConnectRoute,
  EvaluatorsEvaluatorIdRoute: EvaluatorsEvaluatorIdRoute,
  EvaluatorsDashboardRoute: EvaluatorsDashboardRoute,
  EvaluatorsNewRoute: EvaluatorsNewRoute,
  FindingsFindingIdRoute: FindingsFindingIdRoute,
  PlatformAdminTenantIdRoute: PlatformAdminTenantIdRoute,
  PlatformAdminScheduledJobsRoute: PlatformAdminScheduledJobsRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ReviewQueueActionIdRoute: ReviewQueueActionIdRoute,
  SettingsRoleBasedAccessRoute: SettingsRoleBasedAccessRoute,
  AgentInventoryIndexRoute: AgentInventoryIndexRoute,
  AiAppsIndexRoute: AiAppsIndexRoute,
  AiIndexRoute: AiIndexRoute,
  AuditExplorerIndexRoute: AuditExplorerIndexRoute,
  BaaPreflightIndexRoute: BaaPreflightIndexRoute,
  ConversationsIndexRoute: ConversationsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DiscoveryIndexRoute: DiscoveryIndexRoute,
  EvaluatorsIndexRoute: EvaluatorsIndexRoute,
  FindingsIndexRoute: FindingsIndexRoute,
  ModelCardsIndexRoute: ModelCardsIndexRoute,
  PlatformAdminIndexRoute: PlatformAdminIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ReviewQueueIndexRoute: ReviewQueueIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TenantAdminIndexRoute: TenantAdminIndexRoute,
  WorkflowBuilderIndexRoute: WorkflowBuilderIndexRoute,
  AgentInventoryAgentIdEditRoute: AgentInventoryAgentIdEditRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
  EvaluatorsTestSetsTestSetIdRoute: EvaluatorsTestSetsTestSetIdRoute,
  EvaluatorsTestSetsIndexRoute: EvaluatorsTestSetsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
